import SSpySection from './SSpySection'

export default SSpySection
